import React from "react";
import { Icon, PlainButton } from "@culturehq/components";

import { useProfile } from "app/context";
import { EventLink } from "app/links";
import { Trans } from "app/utils";

import Flag from "components/common/Flag";
import QuickOptions from "components/display/QuickOptions";
import PinUserActivityToggle from "components/feed/feed-item/PinUserActivityToggle";

const QuickLinks = ({ photo, event, isMultiple, userActivity, onUserActivityUpdate }) => {
  const { profile } = useProfile();

  return (
    <QuickOptions>
      <ul className="dropdown-menu">
        {profile.organizationAdmin && (
          <li>
            <PinUserActivityToggle
              userActivity={userActivity}
              onUserActivityUpdate={onUserActivityUpdate}
            />
          </li>
        )}
        <li>
          <EventLink event={event}>
            <Icon icon="android-calendar" />
            <Trans>View Event</Trans>
          </EventLink>
        </li>
        {!isMultiple && (
          <li>
            <Flag action="flagPhoto" options={{ photoId: photo.id }}>
              {onTrigger => (
                <PlainButton onClick={onTrigger}>
                  <Icon icon="ios-flag" />
                  <Trans>Flag this photo as inappropriate</Trans>
                </PlainButton>
              )}
            </Flag>
          </li>
        )}
      </ul>
    </QuickOptions>
  );
};

export default QuickLinks;
